// Where a capture task CAME FROM (SAD-486). Shared by every Capture view that
// lists tasks so the same task reads the same origin everywhere. Renders
// nothing when provenance is unknown (e.g. it failed to load).
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { overviewUrl } from './Overview/overviewNavigation';
export function originLabel(p, areaName) {
    switch(p.originKind){
        case 'area':
            return areaName ? `From area: ${areaName}` : 'From area';
        case 'go_no_go':
            return 'From go/no-go';
        case 'theme':
            return 'From Customer Theme';
        case 'interaction':
            return 'From customer interaction';
        default:
            return 'Added manually';
    }
}
export function CaptureTaskOrigin({ provenance, areaName, captureProjectId }) {
    if (!provenance?.originKind) return null;
    const sourceKind = provenance.originKind;
    const href = captureProjectId && provenance.originRefId && (sourceKind === 'interaction' || sourceKind === 'theme') ? overviewUrl(`/capture/${captureProjectId}`, {
        kind: sourceKind,
        id: provenance.originRefId
    }) : undefined;
    return /*#__PURE__*/ _jsx(SpecraBadge, {
        variant: "neutral",
        "data-testid": Testids.capture.tasksOriginBadge,
        children: href ? /*#__PURE__*/ _jsxs("a", {
            href: href,
            children: [
                originLabel(provenance, areaName),
                " — Open source"
            ]
        }) : originLabel(provenance, areaName)
    });
}
